module.exports = __webpack_public_path__ + "ec6d506a619be308633aaf93d11237b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/carat_diamond_ring@2x.png
// module id = 816
// module chunks = 0